'use client';

import { Text } from '@actr/ui/src/components/_atoms/text';
import { Price } from '@actr/ui/src/components/price';
import { observer } from 'mobx-react-lite';
import React from 'react';

import * as Styled from './style.css';

export type TagProps = {
  name: string;
  price: number;
}

const Tag: React.FC<TagProps> = ({ name, price }) => (
  <div className={Styled.TagWrapper}>
    <Text className={Styled.Title} font="paragraph.m">{name}</Text>
    <Price className={Styled.Amount} font="paragraph.s" prefix="От" amount={price} />
  </div>
);

export default observer(Tag);
